import './index.css'
import cn from 'clsx'

import React from 'react'
import Footer from './footer'
import Section from './section'
type Props = {
  children: React.ReactNode
  disabled?: boolean
  sidebar?: React.ReactNode
}

/**
 * A container component that provides layout structure for pages, with optional sidebar support
 * @param children - Main content to display in the page container
 * @param disabled - Whether the page container should be in a disabled state
 * @param sidebar - Optional sidebar content to display alongside the main content
 * @returns Page container div element with conditional layout based on sidebar presence
 */
const PageContainer = ({
  children,
  disabled,
  sidebar,
}: Props): React.ReactElement<'div'> =>
  sidebar ? (
    <div
      className={cn('PageContainer PageContainer--with-sidebar', {
        'PageContainer--disabled': disabled,
      })}
    >
      <div className="PageContainer-sidebar">{sidebar}</div>
      <div className="PageContainer-main">{children}</div>
    </div>
  ) : (
    <div
      className={cn('PageContainer', {
        'PageContainer--disabled': disabled,
      })}
    >
      {children}
    </div>
  )

PageContainer.Section = Section
PageContainer.Footer = Footer
export default PageContainer
